export function generateUID() {
  var firstPart = (Math.random() * 46656) | 0;
  var secondPart = (Math.random() * 46656) | 0;
  firstPart = ("000" + firstPart.toString(36)).slice(-3);
  secondPart = ("000" + secondPart.toString(36)).slice(-3);
  return firstPart + secondPart;
}

export function topicMatches(match, path) {
  if (match === path) return true;
  const matchTokens = match.split(".");
  const pathTokens = path.split(".");
  let matchedTokens = [];
  let idx = 0;
  matchTokens.forEach((t, i) => {
    if (t === "#") {
      const cTokens = pathTokens.slice(idx);
      let matched;
      if (matchTokens[i + 1]) {
        const cIdx = cTokens.indexOf(matchTokens[i + 1]);
        matched = pathTokens.slice(idx, idx + cIdx);
        idx = idx + cIdx;
      } else {
        matched = pathTokens.slice(idx);
      }
      if (matched.length === 0) matched.push(false);
      matchedTokens = [...matchedTokens, ...matched];
    } else if (t === "+") {
      matchedTokens.push(pathTokens[idx]);
      idx++;
    } else {
      matchedTokens.push(t === pathTokens[idx] ? pathTokens[idx] : false);
      idx++;
    }
  });
  return matchedTokens.join(".") === pathTokens.join(".");
}

export function topicMatcher(map, namespace) {
  if (namespace in map) return map[namespace];
  const topics = Object.keys(map).filter(
    (f) => f.includes("+") || f.includes("#")
  );
  if (topics.length) {
    for (let t of topics) {
      const matches = topicMatches(t, namespace);
      if (matches) {
        return map[t];
      }
    }
  }
}

export default function PubSub() {
  const subscribers = {};

  function publish(namespace, topic, data) {
    const topics = topicMatcher(subscribers, namespace);
    if (!topics) return;
    const listeners = topics[topic];
    if (listeners)
      Object.keys(listeners).forEach((key) => {
        listeners[key](data);
      });
  }

  function subscribe(namespace, topic, callback) {
    if (subscribers[namespace] === undefined) {
      subscribers[namespace] = {};
    }
    const listeners = subscribers[namespace];
    if (listeners[topic] === undefined) {
      listeners[topic] = {};
    }
    const id = generateUID();
    listeners[topic][id] = callback;
    return () => {
      delete listeners[topic][id];
      if (Object.entries(listeners[topic]).length === 0)
        delete listeners[topic];
      if (Object.entries(subscribers[namespace]).length === 0)
        delete subscribers[namespace];
    };
  }

  return {
    publish,
    subscribe,
    subscribers,
  };
}
